<template>
  <vue-context ref="context">
    <li>
      <a href="javassript:;" @click.prevent="onClick('手动出场')">手动出场</a>
    </li>
    <li>
      <a href="javassript:;" @click.prevent="onClick('修改车牌')">修改车牌</a>
    </li>
    <li>
      <a href="javassript:;" @click.prevent="onClick('修改车型')">修改车型</a>
    </li>
    <li>
      <a href="javassript:;" @click.prevent="onClick('修改订单金额')">修改订单金额</a>
    </li>
    <li>
      <a href="javassript:;" @click.prevent="onClick('清除不在场车辆')">清除不在场车辆</a>
    </li>
    <li>
      <a href="javassript:;" @click.prevent="onClick('显示订单二维码')">显示订单二维码</a>
    </li>
  </vue-context>
</template>

<script>
import VueContext from 'vue-context';
import 'vue-context/src/sass/vue-context.scss';

export default {
  name: "rightMenu",
  components: {VueContext},
  data: () => ({
    rightMenu: undefined,
  }),
  mounted() {
    this.rightMenu = this.$refs.context;
  },
  methods: {
    onClick(key) {
      this.$emit('onClick', key);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-context{
  min-width: 110px;
  text-align: left;
}
</style>
